import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateRepairPolicy } from "../api/updateRepairPolicy";

export const useUpdateRepairPolicy = () => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (data) => updateRepairPolicy(data.id, data.payload),
    onSuccess: () => {
      queryClient.invalidateQueries(["repairPolicyMaster"]);
    },
  });

  return { mutate, isPendingUpdate: isPending };
};
